import React, { useState } from 'react';
import cookie from 'js-cookie';

interface Props {
  branches: string[];
}

const getUrlBranch = () => {
  const searchParameters = window.location.hash.split('?')[1];
  const urlParams = new URLSearchParams(searchParameters);
  return urlParams.get('branch');
};

export default function BranchPicker({ branches }: Props) {
  const urlBranch = getUrlBranch();
  const selectedBranch = () => {
    if (urlBranch && branches.includes(urlBranch)) {
      return urlBranch;
    } else {
      return window.branchKey && cookie.get(window.branchKey);
    }
  };
  const [value, setValue] = useState<string>(selectedBranch() ?? window.defaultBranch);

  const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setValue(e.target.value);
    if (window.branchKey) {
      cookie.set(window.branchKey, e.target.value, {
        path: location.pathname
      });
      location.reload();
    }
  };

  return (
    <>
      <select value={value} onChange={handleSelect}>
        {branches.map((branch) => (
          <option key={branch} value={branch}>
            {branch}
          </option>
        ))}
      </select>
    </>
  );
}
